/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Password_Reset_Unavailable_DescriptionInputs */

const en_common_sign_password_reset_unavailable_description = /** @type {(inputs: Common_Sign_Password_Reset_Unavailable_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The administrator hasn't configured an email service yet, so reset links can't be sent. Please contact support.`)
};

const zh_common_sign_password_reset_unavailable_description = /** @type {(inputs: Common_Sign_Password_Reset_Unavailable_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理员尚未配置邮件服务，无法发送重置链接，请联系客服。`)
};

/**
* | output |
* | --- |
* | "The administrator hasn't configured an email service yet, so reset links can't be sent. Please contact support." |
*
* @param {Common_Sign_Password_Reset_Unavailable_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_password_reset_unavailable_description = /** @type {((inputs?: Common_Sign_Password_Reset_Unavailable_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Password_Reset_Unavailable_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_password_reset_unavailable_description(inputs)
	return zh_common_sign_password_reset_unavailable_description(inputs)
});
export { common_sign_password_reset_unavailable_description as "common.sign.password_reset_unavailable_description" }